import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Al cambiar de ruta, sube hasta arriba. Como el reset global usa
// `html, body { overflow-x: hidden }`, por spec de CSS `overflow-y` computa a `auto`
// y el contenedor de scroll real puede ser el body o el elemento raíz según el
// navegador (no siempre `window`). Por eso reseteamos el scroll en TODOS los
// posibles contenedores, y repetimos tras el primer paint por si el contenido
// termina de acomodarse después de montar.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const alTop = () => {
      try { window.scrollTo(0, 0); } catch (e) { /* noop */ }
      if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    };
    alTop();
    const id = requestAnimationFrame(alTop);
    return () => cancelAnimationFrame(id);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
